import { Component, ChangeDetectionStrategy, Input, Output, EventEmitter, OnChanges } from '@angular/core';

import { Product } from '../../../core/models/product';
import { CombinedFacets } from '../../../facets/models/facet';
import { Setting } from '../../../core/models/setting';
import { CartProduct, AddCartEvent } from '../../../cart/models/cart-models';
import { ToggleFavoriteEvent } from '../../../catalog/models/favorite-product';
import { upwardsQuantity, minQuantity, stepping } from '../../../core/helpers/prices';
import * as moment from 'moment'
import { FacetValuesPipe } from '../../pipes/facet-values.pipe';
import { canBuyProduct } from '../../../core/helpers/product';

@Component({
  selector: 'app-product-table-item',
  templateUrl: './product-table-item.component.html',
  styleUrls: ['./product-table-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProductTableItemComponent implements OnChanges {
  startQuantity = 0
  quantity: number

  @Input() product: Product
  @Input() isFavorite: boolean
  @Input() combinedFacets: CombinedFacets
  @Input() catalogItemPageSettings: Setting
  @Input() cartProduct: CartProduct
  @Input() quantityPicker: string
  @Input() allowOutOfStockOrdering: boolean

  @Output() onDetails = new EventEmitter<Product>()
  @Output() onAddCart = new EventEmitter<AddCartEvent>()
  @Output() onFavoriteToggle = new EventEmitter<ToggleFavoriteEvent>()

  constructor(private facetValuesPipe: FacetValuesPipe) { }

  ngOnChanges() {
  }

  getActualQuantity(cartQuantity) {
    this.startQuantity = cartQuantity > 0
      ? cartQuantity
      : 0
  }

  get thumbUrl(): string {
    if (this.product && this.product.assets && this.product.assets.imgs && this.product.assets.imgs.length > 0) {
      const img = this.product.assets.imgs.find(img => img.type === 'thumb')

      if (img && img.src) {
        return img.src
      }
    }

    return '/assets/images/no-image-placeholder.png'
  }

  get price(): number {
    if (this.product && this.product.price && this.product.price.prices && this.product.price.prices.length) {
      return this.product.price.prices[0].price
    }
  }

  get currency(): string {
    if (this.product && this.product.price && this.product.price.prices && this.product.price.prices.length) {
      return this.product.price.prices[0].currency
    }
  }

  get actualQuantity(): number {
    return upwardsQuantity(this.product, this.quantity || this.startQuantity)
  }

  get minQuantity(): number {
    return minQuantity(this.product)
  }

  get stepping(): number {
    return stepping(this.product)
  }

  get canBuy(): boolean {
    return canBuyProduct(this.product, this.allowOutOfStockOrdering);
  }

  get isProductInBackorder(): boolean {
    return (this.product && this.product.backorderInfo && this.product.backorderInfo.totalInBackorder > 0)
  }

  getWeekAndYearFromDateString(value: string): string {
    const date = moment(value)

    if (date.isValid()) {
      return moment(value).format('w, YYYY')
    }

    return ''
  }

  getWeekFromDateString(value: string): string {
    const date = moment(value)

    if (date.isValid()) {
      return moment(value).format('w')
    }

    return ''
  }

  addCart(event: AddCartEvent) {
    this.onAddCart.emit({
      product: this.product._id,
      quantity: event.quantity
    })
  }

  toggleFavorite(e: MouseEvent) {
    e.stopPropagation()
    this.onFavoriteToggle.emit({
      isFavorite: this.isFavorite,
      product: this.product
    })
  }

  openDetails() {
    this.onDetails.emit(this.product)
  }

  get inCart(): boolean {
    return !!this.cartProduct && this.cartProduct.inCart
  }

  getFacetValues(facetCode: string): string {
    return this.facetValuesPipe.transform(this.product.facets, facetCode, this.combinedFacets)
  }
}
